module.exports = __webpack_public_path__ + "static/media/IMG_3499_sm.3df40dfc.jpg";